import { AxiosError } from "axios"
import clientApi from "@/shared/api/client"
import { SEARCH_URL } from "@/entities/search/api/url"
import { ApiResponse } from "@/shared/types/interface/api"
import { AutoCompleteRequest, AutoCompleteResponse, SearchRequest, SearchResultPayload } from "@/shared/types/type/search"

export const getSearchResultClient = async (params: SearchRequest) => {
  try {
    const response = await clientApi.post(SEARCH_URL.SEARCH, {
      ...params,
    })
    if (response.status !== 200) {
      throw new Error("Failed to get search results")
    }
    return response.data as ApiResponse<SearchResultPayload>
  } catch (error) {
    if (error instanceof AxiosError) {
      if (!error.response) {
        throw new Error("No Response")
      }
    }
    throw error
  }
}

export const getAutoCompleteClient = async (params: AutoCompleteRequest) => {
  try {
    const response = await clientApi.get(SEARCH_URL.AUTO_COMPLETE, {
      params: {
        ...params,
      },
    })
    if (response.status !== 200) {
      throw new Error("Failed to get auto complete")
    }
    if (response.data.status !== 200) {
      const error = new AxiosError(response.data.message)
      error.response = {
        ...response,
        status: response.data.status,
        statusText: response.data.message || "Error",
      } as AxiosError["response"]
      throw error
    }
    return response.data as ApiResponse<AutoCompleteResponse[]>
  } catch (error) {
    if (error instanceof AxiosError) {
      if (!error.response) {
        throw new Error("No Response")
      }
    }
    throw error
  }
}
